/**
 * Section 2 — Use of Information
 * Exact legal text from the approved Privacy Policy prototype.
 */

import { BulletPoint } from '../BulletPoint';

export const UseOfInformation = () => (
  <div className="font-termina text-xl max-md:text-2xl">
    <br />
    <br />

    <h2 className="font-recoleta font-black">2. Use of Information</h2>
    <div className="w-full font-termina">
      <br />
      The information bQuest collects is used in a variety of ways, including:
    </div>
    <br />

    <BulletPoint>for internal review;</BulletPoint>
    <br />

    <BulletPoint>to improve the Services;</BulletPoint>
    <br />

    <BulletPoint>
      to optimize third-party offers of products and/or services;
    </BulletPoint>
    <br />

    <BulletPoint>
      to recommend Providers to you consistent with your stated goals;
    </BulletPoint>
    <br />

    <BulletPoint>to notify you about updates to the Services;</BulletPoint>
    <br />

    <BulletPoint>
      to let you know about products, services, and promotions that you may be
      interested in;
    </BulletPoint>
    <br />

    <BulletPoint>to solicit feedback or User Content;</BulletPoint>
    <br />

    <BulletPoint>
      for our marketing purposes and the marketing of discounts offered through
      our Services by Providers;
    </BulletPoint>
    <br />

    <BulletPoint>
      to secure, fulfill, and provide our Services, including personalized or
      enhanced services requested by you;
    </BulletPoint>
    <br />

    <BulletPoint>
      internal business analysis or other business purposes consistent with our
      mission;and to carry out other purposes that are disclosed to you and to
      which you consent;
    </BulletPoint>
    <br />
  </div>
);
